import "./Toast.scss";
const Toast = ({ message, isSuccess, onClose }) => (
  <div className={`alert toast ${isSuccess ? "success" : "error"}`}>
    <p>
      {isSuccess ? (
        <span className="success-text">Success:</span>
      ) : (
        <span className="error-text">Error:</span>
      )}{" "}
      {message}
    </p>
  </div>
);

export default Toast;
